/* eslint-disable @typescript-eslint/no-unused-vars */
import { create } from "zustand";

interface NavigationState {
  isMenuOpen: boolean;
  setIsMenuOpen: (status?: boolean) => void;
}

const useNavigationStore = create<NavigationState>((set) => ({
  isMenuOpen: false,
  setIsMenuOpen: (status) =>
    set((state) => {
      return { isMenuOpen: status };
    }),
}));

export default useNavigationStore;
